import React from 'react';
import {
  StructuredTableColumn,
  StructuredTaskDataTable,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { formattedAddress, TRLAddress } from '../../../tasks/types/trl';
import { dateToString } from '../../utilities/formattingUtilities';

export const RenderAddressSection = ({
  addressHistory,
}: {
  addressHistory: TRLAddress[];
}) => {
  const formattedTableData = formatData(addressHistory);
  const columns: StructuredTableColumn[] = [
    {
      key: Resource.TRL_ADDRESS_STATUS_KEY,
      label: Resource.TRL_ADDRESS_STATUS,
    },
    {
      key: Resource.TRL_ADDRESS_TYPE_KEY,
      label: Resource.TRL_ADDRESS_TYPE,
    },
    {
      key: Resource.TRL_ADDRESS_ADDRESS_KEY,
      label: Resource.TRL_ADDRESS_ADDRESS,
    },
    {
      key: Resource.TRL_ADDRESS_ON_FILE_SINCE_KEY,
      label: Resource.TRL_ADDRESS_ON_FILE_SINCE,
    },
  ];

  return (
    <StructuredTaskSection title={Resource.TRL_ADDRESS_SUBTITLE}>
      <StructuredTaskDataTable
        columns={columns}
        rows={formattedTableData}
        rowKey={(_, index) => `trl-address-row-${index}`}
      />
    </StructuredTaskSection>
  );
};

function formatData(addressHistory: TRLAddress[]) {
  const formattedTableData = addressHistory.map(address => {
    return {
      status: formatAddressStatus(address.status),
      type: formatAddressType(address.type),
      address: formattedAddress(address),
      onFileSince: dateToString(address.onFileSince),
    };
  });
  formattedTableData.sort(
    (a, b) =>
      a.status.localeCompare(b.status) ||
      b.onFileSince.localeCompare(a.onFileSince),
  );
  return formattedTableData;
}

function formatAddressStatus(data: string) {
  if (
    data.toLocaleLowerCase() ===
    Resource.TRL_ADDRESS_STATUS_CURRENT.toLocaleLowerCase()
  ) {
    return Resource.TRL_ADDRESS_STATUS_CURRENT;
  } else if (
    data.toLocaleLowerCase() ===
    Resource.TRL_ADDRESS_STATUS_PREVIOUS.toLocaleLowerCase()
  ) {
    return Resource.TRL_ADDRESS_STATUS_PREVIOUS;
  } else {
    return '';
  }
}

function formatAddressType(data: string) {
  if (
    data.toLocaleLowerCase() ===
    Resource.TRL_ADDRESS_TYPE_PERSONAL.toLocaleLowerCase()
  ) {
    return Resource.TRL_ADDRESS_TYPE_PERSONAL;
  } else if (
    data.toLocaleLowerCase() ===
    Resource.TRL_ADDRESS_TYPE_BUSINESS.toLocaleLowerCase()
  ) {
    return Resource.TRL_ADDRESS_TYPE_BUSINESS;
  } else {
    return '';
  }
}
